/**
 * @link https://mui.com/material-ui/react-tooltip/
 */


import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeTooltip() {
  return (
    <>
      <br/>
      <br/>
        <Box sx={{ width: '100%' }}>
          <Grid container justifyContent="center">
            <Box sx={{ width: 650 }}>
          <Grid container justifyContent="center">
            <Grid item>
              <Tooltip title="This is a Tooltip" placement="top-start" arrow>
                <Button>top-start</Button>
              </Tooltip>
              <Tooltip title="This is a Tooltip" placement="top" arrow>
                <Button>top</Button>
              </Tooltip>
              <Tooltip title="This is a Tooltip" placement="top-end" arrow>
                <Button>top-end</Button>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item xs={6}>
              <Tooltip title="This is a Tooltip" placement="left-start" arrow>
                <Button>left-start</Button>
              </Tooltip>
              <br />
              <Tooltip title="This is a Tooltip" placement="left" arrow>
                <Button>left</Button>
              </Tooltip>
              <br />
              <Tooltip title="This is a Tooltip" placement="left-end" arrow>
                <Button>left-end</Button>
              </Tooltip>
            </Grid>
            <Grid item container xs={6} alignItems="flex-end" direction="column">
              <Grid item>
                <Tooltip title="This is a Tooltip" placement="right-start" arrow>
                  <Button>right-start</Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="This is a Tooltip" placement="right" arrow>
                  <Button>right</Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title="This is a Tooltip" placement="right-end" arrow>
                  <Button>right-end</Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item>
              <Tooltip title="This is a Tooltip" placement="bottom-start" arrow>
                <Button>bottom-start</Button>
              </Tooltip>
              <Tooltip title="This is a Tooltip" placement="bottom" arrow>
                <Button>bottom</Button>
              </Tooltip>
              <Tooltip title="This is a Tooltip" placement="bottom-end" arrow>
                <Button>bottom-end</Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
          </Grid>
        </Box>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Tooltip */}
  <Tooltip title="This is a basic tooltip" arrow>
    <Button>Hover me</Button>
  </Tooltip>
  
  {/* Tooltip placement examples */}
  <Box sx={{ width: '100%' }}>
    <Grid container justifyContent="center">
      {/* Top placements */}
      <Grid item>
        <Tooltip title="Tooltip on top start" placement="top-start" arrow>
          <Button>top-start</Button>
        </Tooltip>
        <Tooltip title="Tooltip on top" placement="top" arrow>
          <Button>top</Button>
        </Tooltip>
        <Tooltip title="Tooltip on top end" placement="top-end" arrow>
          <Button>top-end</Button>
        </Tooltip>
      </Grid>
      
      {/* Bottom placements */}
      <Grid item>
        <Tooltip title="Tooltip on bottom" placement="bottom" arrow>
          <Button>bottom</Button>
        </Tooltip>
      </Grid>
      
      {/* Left placement */}
      <Grid item>
        <Tooltip title="Tooltip on left" placement="left" arrow>
          <Button>left</Button>
        </Tooltip>
      </Grid>
      
      {/* Right placement */}
      <Grid item>
        <Tooltip title="Tooltip on right" placement="right" arrow>
          <Button>right</Button>
        </Tooltip>
      </Grid>
    </Grid>
  </Box>
</>`} 
        scope={{ React, Box, Grid, Button, Tooltip }} 
      />
    </>
  );
}